import "./App.css";
import AppRouter from "./routes/AppRouter";
import React, { useState } from "react";
import { MobileIcon } from "./components/MobileIcon";
import { ToastProvider } from "./components/ToastProvider";

function App() {
  const [isDesktop] = useState(false);

  if (isDesktop) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
        <MobileIcon />
        <h1 className="text-2xl font-bold text-gray-800 mt-4">
          Please view the webpage in mobile
        </h1>
        <p className="text-gray-600 mt-2">
          This app is optimized for mobile devices
        </p>
      </div>
    );
  }

  return (
    <ToastProvider>
      <AppRouter />
    </ToastProvider>
  );
}

export default App;
